import React from 'react';

import type { BranchUI } from '@/common/types/vip-vendor-contact-us.type';

import Text from '@/common/components/text';

import AddressRow from './address-row.component';

export default function SectionInfo({ branch }: { branch: BranchUI }) {
  const { address, mobiles, phones, faxs, emails } = branch;

  return (
    <div className="flex w-full flex-col gap-4">
      {address && <AddressRow value={address} />}

      {mobiles?.length ? (
        <div className="flex w-full flex-row justify-between rounded-md bg-gray-30 p-3">
          <Text className="flex items-center justify-center text-sm font-medium text-gray-700">
            شماره همراه:
          </Text>
          <div className="flex flex-col gap-1">
            {mobiles.map((m) => (
              <Text
                className="text-left text-sm font-medium text-gray-700"
                key={m}
              >
                {m}
              </Text>
            ))}
          </div>
        </div>
      ) : null}

      {phones?.length ? (
        <div className="flex w-full flex-row justify-between rounded-md bg-gray-30 p-3">
          <Text className="flex items-center justify-center text-sm font-medium text-gray-700">
            شماره تماس:
          </Text>
          <div className="flex flex-col gap-1">
            {phones.map((m) => (
              <Text
                className="text-left text-sm font-medium text-gray-700"
                key={m}
              >
                {m}
              </Text>
            ))}
          </div>
        </div>
      ) : null}

      {faxs?.length ? (
        <div className="flex w-full flex-row justify-between rounded-md bg-gray-30 p-3">
          <Text className="flex items-center justify-center text-sm font-medium text-gray-700">
            شماره فکس:
          </Text>
          <div className="flex flex-col gap-1">
            {faxs.map((m) => (
              <Text
                className="text-left text-sm font-medium text-gray-700"
                key={m}
              >
                {m}
              </Text>
            ))}
          </div>
        </div>
      ) : null}

      {emails?.length ? (
        <div className="flex w-full flex-row justify-between rounded-md bg-gray-30 p-3">
          <Text className="flex items-center justify-center text-sm font-medium text-gray-700">
            ایمیل:
          </Text>
          <div className="flex flex-col gap-1">
            {emails.map((m) => (
              <Text
                className="text-left text-sm font-medium text-gray-700"
                key={m}
              >
                {m}
              </Text>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
